<template>
  <section class="pricing_view__container">
    <h4 class="pricing_view__title color-secondary">Pricing</h4>
    <p class="pricing_view__description">
      Separate advisor selling prices from the consumer-facing price.
    </p>

    <div class="card pricing_view__card mt-4">
      <div v-if="pricing.length > 0" class="card-content">
        <b-tabs v-model="activeTab" class="pricing_view__tabs">
          <b-tab-item
            v-for="(item, index) in pricing"
            :key="index"
            :label="item.title.value"
          >
            <ckeditor
              v-model="item.content.value"
              :editor="editor"
              :config="editorConfig"
            />
          </b-tab-item>
        </b-tabs>
        <footer class="card-footer pricing_view__footer pr-0">
          <div class="card-footer-item is-justify-content-flex-end pb-0">
            <BaseButton
              size="medium"
              action="tercery"
              :loading="isSaving"
              @click="saveEdit"
            >
              <i slot="icon" class="mr-4 ml-1">
                <IconCheck class="icon is-small" />
              </i>
              <p slot="text">Save</p>
            </BaseButton>
          </div>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mapGetters } from "vuex";
import IconCheck from "@/components/icons/IconCheck.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import { openToast } from "@/utils/utils";
import helpers from "@/helpers";
import clonedeep from "lodash.clonedeep";

const defaultPricing = [
  {
    title: { id: null, value: "Selling Prices" },
    content: { id: null, value: "" },
  },
  {
    title: { id: null, value: "Consumer Price" },
    content: { id: null, value: "" },
  },
];

export default {
  name: "PricingView",
  components: {
    ckeditor: CKEditor.component,
    BaseButton,
    IconCheck,
  },
  props: {
    loadItinerary: {
      type: Function,
      default: () => {},
    },
    setLoading: Function,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      isSaving: false,
      activeTab: 0,
      pricing: [],
    };
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      formItinerary: "itinerary/getFormItinerary",
    }),
  },
  watch: {
    itinerary: {
      deep: true,
      immediate: true,
      handler({ data: itinerary }) {
        if (itinerary) {
          this.pricing = clonedeep(
            itinerary.pricing_itinerary?.length
              ? itinerary.pricing_itinerary
              : defaultPricing
          );
        }
      },
    },
  },
  activated() {
    if (this.$route.query.itinerary) {
      if (!this.itinerary.data) {
        this.loadItinerary();
        this.setLoading(false);
      } else {
        this.pricing = clonedeep(
          this.itinerary.data.pricing_itinerary?.length
            ? this.itinerary.data.pricing_itinerary
            : defaultPricing
        );
      }
    }
  },
  methods: {
    async saveEdit() {
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      const itinerary = this.itinerary.data;

      this.isLoading = true;
      this.isSaving = true;

      itinerary.pricing_itinerary.forEach((pricing, index) => {
        helpers.applyTranslation(
          itinerary.language.language_code,
          pricing.title,
          this.pricing[index].title.value
        );

        helpers.applyTranslation(
          itinerary.language.language_code,
          pricing.content,
          this.pricing[index].content.value
        );
      });

      const payload = {
        ...this.formItinerary[0],
        pricing_itinerary: itinerary.pricing_itinerary,
        cur_step: 1,
        last_step: 1,
      };

      await this.$store
        .dispatch("itinerary/update", payload)
        .then(() => {
          openToast(this.$buefy, "Pricing saved successfully!", "is-success");
          this.loadItinerary();
        })
        .catch((error) => {
          this.isSaving = false;
          throw error;
        });

      this.isSaving = false;
    },
  },
};
</script>

<style>
.pricing_view__container {
  margin-top: 2rem;
}
.pricing_view__title {
  font-size: 1.15rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.pricing_view__description {
  margin-top: 0.5rem;
  color: var(--gray-dark);
}
.pricing_view__footer {
  border-top: none;
  margin-top: 1rem;
}
.pricing_view__tabs .ck-editor__editable_inline {
  min-height: 300px;
}
@media screen and (max-width: 480px) {
  .pricing_view__container {
    margin-top: 1rem;
  }
}
</style>
